webpackJsonp([120561760088751],{

/***/ "./gatsby-config.js":
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'ecomChicago 2017 | A three day conference for online store owners and marketplace sellers',
	    gMapsUrl: 'https://www.google.com/maps/api/js?key=AIzaSyCS1j9k6FEHLsXt5T_xyUWTJ6hqM3FTVyU',
	    registrationUrl: 'http://events.r20.constantcontact.com/register/event?oeidk=a07ee6m5j4sf8812454&llr=mvn944bab&showPage=true'
	  },
	  plugins: [{
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      name: 'data',
	      path: __dirname + '/src'
	    }
	  }, 'gatsby-transformer-remark', 'gatsby-transformer-json', 'gatsby-plugin-sass']
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ "./src/sections/DetailLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = DetailLinks;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyConfig = __webpack_require__("./gatsby-config.js");
	
	var _gatsbyConfig2 = _interopRequireDefault(_gatsbyConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DetailLinks() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'detail-links' },
	    _react2.default.createElement(
	      'a',
	      {
	        className: 'button',
	        href: _gatsbyConfig2.default.siteMetadata.registrationUrl
	      },
	      'Register Now'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      'Go Back'
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/templates/info.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/sioked/Development/ecomchicago/node_modules/babel-preset-react/lib/index.js\",\"/Users/sioked/Development/ecomchicago/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/sioked/Development/ecomchicago/node_modules/babel-preset-stage-1/lib/index.js\",[\"/Users/sioked/Development/ecomchicago/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/sioked/Development/ecomchicago/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/sioked/Development/ecomchicago/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/sioked/Development/ecomchicago/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/sioked/Development/ecomchicago/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/sioked/Development/ecomchicago/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/sioked/Development/ecomchicago/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/speaker.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DetailLinks = __webpack_require__("./src/sections/DetailLinks.jsx");
	
	var _DetailLinks2 = _interopRequireDefault(_DetailLinks);
	
	__webpack_require__("./src/templates/info.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SpeakerTemplate(props) {
	  var speaker = props.data.markdownRemark;
	  return _react2.default.createElement(
	    'div',
	    { className: 'content-page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'info-container' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        speaker.frontmatter.name
	      ),
	      _react2.default.createElement('img', {
	        className: 'bio-image',
	        src: speaker.frontmatter.image,
	        alt: speaker.frontmatter.name
	      }),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: speaker.html } }),
	      _react2.default.createElement(_DetailLinks2.default, null)
	    )
	  );
	}
	
	exports.default = SpeakerTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-speaker-js-bedcb2502c7fdbf82018.js